import { useEffect, useState, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useQuery } from "react-query";

// import "./inc/Classes";

import "./App.css";
import { AppContext } from "./Context";

import Site from "./pages/site";
import Tasks from "./pages/site/tasks";
import Games from "./pages/site/games";
import Audio from "./pages/site/audio";
import Books from "./pages/site/books";
import Content from "./pages/site/content";

import Main from "./pages/Main";
import Login from "./pages/Login";

import TaskStart from "./pages/task/start";
import TaskView from "./pages/task/view";
import TaskStudentView from "./pages/task/view_student";
import MyTasks from "./pages/task/myTasks";
import AudioView from "./pages/site/audio/Audio.js";
import TaskPrint from "./pages/task/print";
import TaskNew from "./pages/task/new";
import TaskSend from "./pages/task/send";
import TaskPapers from "./pages/task/TaskPapers";
import Fav from "./pages/task/fav";
import SelectSchool from "./pages/SelectSchool";
import ShowQuestions from "./pages/task/showQuestion";

import TaskStatsDownload from "./pages/task/TaskStatsDownload";
import AllTaskStatsDownload from "./pages/task/AllTaskStatsDownload";

import Send from "./pages/task/send";

import Classes from "./inc/Classes";
import TinyPopups from "./components/tiny/TinyPopups";
import Success from "./pages/popups/Success";

import Fetch, { Loader, dateToText, GET } from "./inc/Fetch";
import SendGame from "./pages/task/sendGame.js";
import MyGames from "./pages/task/myGames.js";
import GamesResults from "./pages/task/GamesResults.js";
import UserInfo from "./pages/task/UserInfo.js";
import MyStudents from "./pages/task/MyStudents.js";
import EditStudent from "./pages/popups/EditStudent.js";
import Permission from "./pages/Permission.js";
import Permission_pop from "./pages/Permission_pop.js";
import Smoosic from "./pages/site/smoosic.js";
import MoeLogin from "./pages/MoeLogin.js";
import Logout from "./pages/logout.js";
import TaskNotes from "./pages/task/TaskNotes.js";

function App() {
    const [pos, setpos] = useState(false);
    const [loader, setloader] = useState(true);

    const [success, setsuccess] = useState(false);
    const [userinfo, setuserinfo] = useState({});
    const [site, setsite] = useState([]);
    const [article, setarticle] = useState({});
    const [cart, setcart] = useState([]);
    const [loginForm, setloginForm] = useState(false);
    const [showquestion, setshowquestion] = useState(false);

    const contextVars = {
        successData: [success, setsuccess],
        userData: [userinfo, setuserinfo],
        siteData: [site, setsite],
        cartData: [cart, setcart],
        loginForm: [loginForm, setloginForm],
        showQuestions: [showquestion, setshowquestion],
    };

    const location = useLocation();
    let previousLocation = location.state?.previousLocation;
    if (!previousLocation) {
        previousLocation = location;
    }

    async function loadData() {
        let r = await GET("home");

        setuserinfo(r?.user);
        setsite(r?.cats);
        setarticle(r?.article);
        setloader(false);

        let arr = [];
        r?.fav?.map((v) => {
            arr.push(v?.data?.id);
        });

        setcart(arr);

        return r;
    }

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://website-widgets.pages.dev/dist/sienna.min.js";
        script.defer = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    if (loader) {
        return (
            <>
                <Loader />
                <Classes />
            </>
        );
    }

    return (
        <AppContext.Provider value={contextVars}>
            {loginForm && <Login />}
            {success && <Success data={success} />}
            {showquestion && (
                <ShowQuestions setOpen={setshowquestion} data={showquestion} />
            )}

            <Routes location={previousLocation}>
                <Route
                    path="/"
                    element={<Main data={site} article={article} />}
                />

                <Route path="/moeLogin" element={<MoeLogin />} />

                <Route path="/site/:id" element={<Site />} />

                <Route path="/site/:id/lessons" element={<Tasks />} />
                <Route path="/site/:id/lessons/:page" element={<Tasks />} />

                <Route path="/site/:id/audio" element={<Audio />} />
                <Route path="/site/:id/audio/:page" element={<Audio />} />

                <Route path="/site/:id/tasks" element={<Tasks />} />
                <Route path="/site/:id/tasks/:page" element={<Tasks />} />

                <Route path="/site/:id/games" element={<Games />} />
                <Route path="/site/:id/content/:_id" element={<Content />} />

                <Route path="/site/:id/books" element={<Books />} />
                <Route path="/site/:id/smoosic" element={<Smoosic />} />

                {userinfo?._id && (
                    <>
                        <Route path="/fav" element={<Fav />} />
                        <Route path="/lesson/new/:cat" element={<TaskNew />} />
                        <Route
                            path="/lesson/new/:cat/:id"
                            element={<TaskNew />}
                        />
                        <Route
                            path="/lesson/new/:cat/:id/:type"
                            element={<TaskNew />}
                        />

                        <Route path="/task/new/:cat" element={<TaskNew />} />
                        <Route
                            path="/task/new/:cat/:id"
                            element={<TaskNew />}
                        />
                        <Route
                            path="/task/new/:cat/:id/:type"
                            element={<TaskNew />}
                        />

                        <Route path="/task/print/:id" element={<TaskPrint />} />
                        <Route
                            path="/task/print/:id/:type"
                            element={<TaskPrint />}
                        />
                        <Route path="/task/:id" element={<TaskView />} />
                        <Route path="/task/start/:id" element={<TaskStart />} />

                        {userinfo?.userlevel >= 3 ? (
                            <>
                                <Route
                                    path="/taskStatsDownload/:id"
                                    element={<TaskStatsDownload />}
                                />
                                <Route
                                    path="/AllTaskStatsDownload"
                                    element={<AllTaskStatsDownload />}
                                />

                                <Route path="/myGames" element={<MyGames />} />
                                <Route
                                    path="/myGames/:id"
                                    element={<MyGames />}
                                />
                                <Route
                                    path="/games_results"
                                    element={<GamesResults />}
                                />
                                <Route
                                    path="/MyStudents"
                                    element={<MyStudents />}
                                />
                            </>
                        ) : (
                            false
                        )}

                        <Route path="/userinfo" element={<UserInfo />} />
                        <Route path="/myTasks" element={<MyTasks />} />
                        <Route path="/myTasks/:id" element={<MyTasks />} />
                        <Route
                            path="/myTasks/student/:id/:student"
                            element={<TaskStudentView />}
                        />

                        <Route path="/audio/:id" element={<AudioView />} />
                    </>
                )}

                <Route path="/logout_moe" element={<Logout />} />

                <Route path="*" element={<Login />} />
            </Routes>

            <Routes>
                {/* <Route path="/task/add" element={<Login />} /> */}
                <Route path="/newTask" element={<TaskNew />} />
                <Route path="/newTask/:id" element={<TaskNew />} />

                <Route path="/sendTask" element={<TaskSend />} />
                <Route path="/sendTask/:id" element={<TaskSend />} />

                <Route path="/sendGame" element={<SendGame />} />
                <Route path="/sendGame/:id" element={<SendGame />} />

                <Route path="/sendTask/:id/:task" element={<TaskSend />} />
                <Route path="/SelectSchools" element={<SelectSchool />} />

                <Route path="/tasksPapger/:id" element={<TaskPapers />} />

                {userinfo?.userlevel >= 3 ? (
                    <>
                        <Route
                            path="/myStudents/edit/:id"
                            element={<EditStudent />}
                        />
                    </>
                ) : (
                    false
                )}

                <Route path="/login" element={<Login />} />
                <Route path="/permission" element={<Permission_pop />} />
                <Route path="/task_notes" element={<TaskNotes />} />
            </Routes>
        </AppContext.Provider>
    );
}

export default App;
